import React from 'react';
import RadarChart from '@common/radarChart';
import { PaccProfileResultVO } from '@domain/vo/phs/pacc/competence/PaccProfileResultVO';
import { Factor, factorTypeContentsMap, factorTypeStringMap } from '@domain/constant/factorType';
import classNames from 'classnames/bind';
import styles from './competencyRadar.module.scss';

const cx = classNames.bind(styles);

const RANKS = ['1st', '2nd', '3rd'];

interface CompetencyRadarProps {
  paccProfileResult: PaccProfileResultVO;
}

const CompetencyRadar = ({ paccProfileResult }: CompetencyRadarProps) => {
  const { factors, topFactorTypes } = paccProfileResult;

  if (!factors) return null;

  const getRadarChartData = factors
    ?.sort((a, b) => Object.keys(Factor).indexOf(a.type) - Object.keys(Factor).indexOf(b.type))
    ?.map((accProfileFactor) => {
      const { type, score } = accProfileFactor;
      const isHigh = !!topFactorTypes?.find((factorType) => {
        return factorType === type;
      });

      return {
        title: factorTypeStringMap[type],
        values: [score],
        emphasized: isHigh,
        tooltipTitle: `${factorTypeContentsMap[type].name} 역량`,
        tooltipContents: `${factorTypeContentsMap[type].description}`,
      };
    });

  return (
    <>
      {/* [D] 레이더 차트 영역 */}
      <RadarChart radarChartDataList={getRadarChartData} />

      {/* [D] 랭킹 영역 */}
      <div className={cx('rankArea')}>
        {topFactorTypes?.map((factorType, index) => (
          <div key={index} className={cx('rankWrap')}>
            <span className={cx('rank')}>{RANKS[index]}</span>
            <span className={cx('keyword')}>{factorTypeStringMap[factorType]}</span>
          </div>
        ))}
      </div>
    </>
  );
};

export default CompetencyRadar;
